import api from "../../../../../api";

export const fetchUserFiltersData = async () => {
  const res = await api.get("/userfiltersuser");
  return res.data;
};

export const deleteUserFilter = async (id_car_make) => {
  await api.delete(`/userfilter/${id_car_make}`);
};

export const saveUserFilters = async (selectedCars, userid, maxMakesAllowed) => {
  const currentUserFilters = await api.get("/userfiltersuser");
  const currentCount = currentUserFilters.data.length;

  for (const car of selectedCars) {
    if (!car.models || !Array.isArray(car.models)) continue;

    const filteredModels = car.models.map(model => ({
      id_car_model: model.id_car_model,
      generations: model.generations.map(gen => ({
        id_car_generation: gen.id_car_generation
      }))
    }));

    const existing = await api.get(`/userfilter/${car.id_car_make}`);
    const data = {
      name: car.name,
      id_car_make: car.id_car_make,
      id_car_user: userid,
      models: filteredModels,
    };

    if (existing.data && Object.keys(existing.data).length > 0) {
      await api.put(`/userfilter/${car.id_car_make}`, data);
    } else {
      if (currentCount >= maxMakesAllowed) {
        console.log(currentCount)
        throw new Error("Prekoračen maksimalan broj asortimana.");
      }
      await api.post("/userfilter", data);
    }
  }

  const updatedFilters = await api.get("/userfiltersuser");
  return updatedFilters.data;
};
